import { createNewHandbookApi } from '@/api/handbookApi'
import { POSITION_PROPERTY_URL } from '@/api/handbook/position'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const HOOK_TYPE_URL = `${POSITION_PROPERTY_URL}/hook-types`

const errors = createHandbookResponseErrors('тип зацепа', 'типов зацепа')

export const HookTypeApi = createNewHandbookApi(HOOK_TYPE_URL, errors)
